module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Abbreviations"
    }
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("Abbreviations")])]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('p', {
    staticClass: "abb"
  }, [_vm._v("ABC")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "80%"
    }
  }, [_c('p', {
    staticClass: "abb"
  }, [_vm._v("American-British Conversations")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("ADB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("American-Dutch-British")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("AEF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("American Expeditionary Force")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("BEF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("British Expeditionary Force")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("BJSM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("British Joint Staff Mission, Washington, D.C.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("CINC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("commander in chief")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("CNO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("chief of naval operations")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("RAF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Royal Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("SPENAVO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("special naval observer")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("SPOBS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Special Army Observer Group in London")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("SWC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Supreme War Council")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("USSOG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("U.S. Special Observer Group")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("WPD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("War Plans Division")])])])])])])]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27494785","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_Abbreviations.vue
// module id = 90
// module chunks = 0